/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// helper
import { fontSizeBaseline } from 'utils/styles'
// animations
import { slideIn, slideOut } from 'utils/animations/slide';
import { fadeIn, fadeOut } from 'utils/animations/fade';
import { flip, flipIn, flipOut } from 'utils/animations/flip';
import { shake, headShake } from 'utils/animations/shake';
// import { wobble } from 'utils/animations/wobble';
import { tada } from 'utils/animations/tada';
// import { swing } from 'utils/animations/swing';
import { rubberBand } from 'utils/animations/rubberband';
import { pulse } from 'utils/animations/pulse';
// import { jello } from 'utils/animations/jello';
// import { hinge } from 'utils/animations/hinge';
// import { flash } from 'utils/animations/flash';
// import { lightSpeedIn, lightSpeedOut } from 'utils/animations/lightspeed';
import { rollIn, rollOut } from 'utils/animations/roll';
import { rotateIn, rotateOut } from 'utils/animations/rotate';
import { settings } from "./config/config";

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// INDEX STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
  // applies styles to the global scope, meaning it will affect all elements so use sparringly (http://cssinjs.org/jss-global)
  '@global': {
    html: {
      fontSize: fontSizeBaseline + 'px'
    },
    '*, *:before, *:after': {
      boxSizing: 'border-box',
      margin: '0',
      padding: '0'
    },
    body: {
      backgroundColor: 'transparent',
      color: '#fff',
      fontFamily: 'Verdana, Arial, sans-serif',
      fontWeight: 'normal',
      fontSize: '1rem',
      lineHeight: '1.5',
      fontSmoothing: 'antialiased' // subpixel-antialiased // ***** needed to cleanup font clarity on webkit browsers ***** //
      // https://forum.webflow.com/t/a-fix-for-when-your-elements-move-up-and-or-blur-during-animations-interactions-on-chrome/11629
    },
    'h1, h2, h3, h4, h5': {
      fontWeight: 'normal'
    },
    a: {
      color: '#568db2'
    },
    'a:hover': {
      color: '#466d87'
    },
    '.accessibility': {
      display: 'none'
    }
  },
  // animations
  fadeOut, fadeIn,
  slideIn, slideOut,
  flip, flipIn, flipOut,
  shake, headShake,
  // wobble,
  tada,
  // swing,
  rubberBand,
  pulse,
  // jello,
  // hinge,
  // flash,
  // lightSpeedIn, lightSpeedOut,
  rollIn, rollOut,
  rotateIn, rotateOut
};